'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  ToolButton: {
    displayName: 'ToolButton'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/ToolButton/ToolButton.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Swipeable from 'react-swipeable';


var object = _react2.PropTypes.object,
    string = _react2.PropTypes.string,
    func = _react2.PropTypes.func,
    oneOfType = _react2.PropTypes.oneOfType,
    bool = _react2.PropTypes.bool;

var ToolButton = _wrapComponent('ToolButton')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(ToolButton, _Component);

  function ToolButton() {
    (0, _classCallCheck3.default)(this, ToolButton);
    return (0, _possibleConstructorReturn3.default)(this, (ToolButton.__proto__ || (0, _getPrototypeOf2.default)(ToolButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToolButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ToolButton.scss');
      var _props = this.props,
          textStyle = _props.textStyle,
          textClassName = _props.textClassName,
          glyphIconName = _props.glyphIconName,
          nofollow = _props.nofollow,
          linkTo = _props.linkTo,
          onClick = _props.onClick,
          children = _props.children,
          inGroup = _props.inGroup,
          inVerticalGroup = _props.inVerticalGroup,
          active = _props.active,
          disabled = _props.disabled;

      var ico = null;
      if (glyphIconName) {
        ico = _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: glyphIconName, style: textStyle, className: textClassName });
      } else {
        ico = _react3.default.createElement(
          'span',
          { style: textStyle, className: textClassName },
          children
        );
      }
      var className = styles.toolButton + (inGroup ? ' ' + styles.inGroup : '') + (active ? ' ' + styles.active : '') + (inVerticalGroup ? ' ' + styles.inVerticalGroup : '');
      if (linkTo) {
        if (nofollow) return _react3.default.createElement(
          _reactRouter.Link,
          { disabled: disabled, to: linkTo, className: className, rel: 'nofollow' },
          ico
        );
        return _react3.default.createElement(
          _reactRouter.Link,
          { disabled: disabled, to: linkTo, className: className },
          ico
        );
      }
      return _react3.default.createElement(
        'button',
        { disabled: disabled, className: className, onClick: onClick },
        ico
      );
    }
  }]);
  return ToolButton;
}(_react2.Component), _class.propTypes = {
  glyphIconName: string,
  textStyle: object,
  textClassName: string,
  onClick: func,
  linkTo: oneOfType([string, object]),
  nofollow: bool,
  inGroup: bool,
  inVerticalGroup: bool,
  active: bool,
  disabled: bool,
  // rel="nofollow"
  children: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node])
  // changeSongText: PropTypes.func.isRequired
}, _temp));

exports.default = ToolButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolButton/ToolButton.js
// module id = 1197
// module chunks = 0